// Styles
import '../../MapStyles/MapMenu.scss';

// React
import { useEffect, useState } from 'react';

// React Bootstrap
import { Card, Form, InputGroup } from 'react-bootstrap';

// Components
import { Icon, Keywords, Text } from '@components';

// Store
import { useMapStore } from '../../MapStore/UseMapStore';

export function MapCreatePlace({ setIsCreating }) {
  const selected = useMapStore((state) => state.selected);
  const newObjCreated = useMapStore((state) => state.newObjCreated);
  const setNewObjName = useMapStore((state) => state.setNewObjName);
  const setNewObjKeywords = useMapStore((state) => state.setNewObjKeywords);
  const setCreatePlace = useMapStore((state) => state.setCreatePlace);
  const addObject = useMapStore((state) => state.addObject);
  const removeTempObject = useMapStore((state) => state.removeTempObject);

  const [name, setName] = useState<string>('');
  const [showSave, setShowSave] = useState<boolean>(false);
  const [keywords, setKeywords] = useState<any>([]);
  const [isInvalid, setIsInvalid] = useState<boolean>(false);

  useEffect(() => {
    setNewObjName(name);
  }, [name, setNewObjName]);

  useEffect(() => {
    setNewObjKeywords(keywords);
  }, [keywords, setNewObjKeywords]);

  useEffect(() => {
    newObjCreated ? setShowSave(true) : setShowSave(false);
  }, [newObjCreated]);

  const handleInput = (value) => {
    value !== '' ? setIsInvalid(false) : setIsInvalid(true);
    setName(value);
  };

  // Handle submission of item
  function startDraw() {
    setCreatePlace(true);
  }

  const handleClick = () => {
    addObject('Place');
    removeTempObject();
    setIsCreating(false);
    setCreatePlace(false);
    setShowSave(false);
  };
  return (
    <Form className={selected !== 'place' ? 'object-wrapper' : 'object-wrapper-expand'}>
      <Card.Body>
        <div className="d-flex flex-column justify-content-between">
          <div className="d-flex flex-row align-items-center justify-content-between">
            <Text className="fw-semibold fs-md mb-3">Place Name:</Text>
            <div>
              {showSave ? (
                <Icon
                  name={'check'}
                  title="Confirm"
                  className="align-sub primary-icon"
                  variant="light"
                  disabled={name === '' ? true : false}
                  size="md"
                  onClick={() => {
                    handleClick();
                  }}
                />
              ) : (
                <Icon
                  name={'pin-edit'}
                  title="Draw Place"
                  className="align-sub primary-icon"
                  variant="light"
                  disabled={name === '' ? true : false}
                  size="md"
                  onClick={() => {
                    startDraw();
                  }}
                />
              )}

              <Icon
                name={'add'}
                title="Close"
                className="sonarIcon-rotate-45 align-sub nav-text-icon"
                variant="light"
                disabled={isInvalid}
                size="md"
                onClick={() => {
                  setCreatePlace(false);
                  setIsCreating(false);
                }}
              />
            </div>
          </div>
          <div className="d-flex align-items-center justify-content-between mb-3">
            <InputGroup className="me-2">
              <Form.Control
                aria-label="Place Name"
                placeholder="Enter a Place name"
                isInvalid={isInvalid}
                value={name}
                onChange={(e) => {
                  handleInput(e.target.value);
                }}
              />
              <Form.Control.Feedback type="invalid">
                Please enter a Place name.
              </Form.Control.Feedback>
            </InputGroup>
          </div>
          <Text className="fw-semibold fs-md mb-3">Keywords:</Text>
          <Keywords isAddingKeyword onChange={(keywords) => setKeywords(keywords)} />
        </div>
      </Card.Body>
    </Form>
  );
}
